import CheckMark from '@/assets/icons/V3/CheckMark.svg?react';

const ProgressBar = ({ englishMarketName }: { englishMarketName: string | undefined }) => {
  const getMarketTitle = (englishMarketName: string | undefined) => {
    switch (englishMarketName) {
      case 'toss':
        return '연동 완료 후';
      default:
        return '오늘';
    }
  };
  return (
    <section className="flex h-[148px] w-[335px] flex-col items-center gap-4 rounded-lg bg-gr-100  py-[32px] pb-[24px]">
      <UpperSection />
      <div className="flex w-full justify-between px-[60px]">
        <div className="flex flex-col items-center">
          <p className="text-gr-700 Body2M16">{getMarketTitle(englishMarketName)}</p>
          <p className="text-gr-800 Body2M16">일주일 정보</p>
        </div>
        <div className="flex flex-col items-center">
          <p className="text-gr-700 Body2M16">일주일 이내</p>
          <p className="text-gr-800 Body2M16">1년 정보</p>
        </div>
      </div>
    </section>
  );
};

const UpperSection = () => {
  return (
    <div className="flex w-full items-center gap-4 px-20">
      <div className="flex h-[32px] w-[32px] items-center justify-center rounded-full bg-gr-900  text-white">
        <CheckMark className="w-[24px]" />
      </div>
      {/* Divider */}
      <div className="flex flex-1">
        <div className="h-px w-[75px]  border-b border-dashed border-gr-900" />
      </div>

      <div className="flex h-[32px] w-[32px] items-center justify-center rounded-full bg-[#d9d9d9] text-gr-900 Body2M16">
        2
      </div>
    </div>
  );
};

export default ProgressBar;
